var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRestartProjectDotsMenu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "restart-project",
    clipPath: "url(#clip0_1170_90838)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M8 0C3.58172 0 0 3.58172 0 8C0 12.4183 3.58172 16 8 16C12.4183 16 16 12.4183 16 8C16 3.58172 12.4183 0 8 0ZM8 3.36621C9.28625 3.36621 10.4496 3.891 11.2891 4.73731L12.6338 3.78028V8.09668L8.50293 6.71972L9.71975 5.85351C9.24868 5.47457 8.65169 5.24708 8.00003 5.24708C6.47963 5.24708 5.24709 6.47959 5.24709 8.00001C5.24709 9.52044 6.4796 10.7529 8 10.7529C9.02037 10.7529 9.90925 10.1968 10.3848 9.37209L12.0156 10.3096C11.2153 11.6979 9.71761 12.6338 8 12.6338C5.44091 12.6338 3.36621 10.5591 3.36621 8C3.36621 5.44093 5.44091 3.36621 8 3.36621Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1170_90838"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRestartProjectDotsMenu);
export default __webpack_public_path__ + "static/media/RestartProjectDotsMenu.8c86dba5a838934a4c7e2cc75e826660.svg";
export { ForwardRef as ReactComponent };